<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div>
          <button type="button" (click)="showBusinessRules()" id="btn_AddNew" style="display:none">Add</button>
          <button type="button" id="btnDeleteBusinessRule" (click)="deleteBusinessRule()" style="display:none">Delete Business Rules</button>
          <button type="button" id="btnDeleteDT" (click)="Deleteconfirmation()" style="display:none">Delete Business Rules</button>
          <button type="button" id="getRuletypeID" (click)="GetRuleTypeId();" style="display:none">Get</button>
          <table #dataTable class="display" style="width:100%"></table>
        </div>
        <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-xl custome-modal" >
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title"> {{title}} </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <!--Loader gif-->
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>

              <div class="modal-body" id="popupbody" >
                <div class="form-group">
                  <div class="row">
                    <!--left side panel-->
                    <div class="col-6">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label for="ddlRuleType">Rule Type</label>
                            <select id="ddlRuleType" class="form-control" onchange="$('#getRuletypeID').trigger('click'); ">
                              <option *ngFor="let item of RuleTypeList" value={{item.Id}}>
                                {{item.RuleType}}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Rules</label>
                            <input id="Txt_RuleID" type="text" class="form-control" autocomplete="off" />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label>Rule Name</label>
                          <input id="Txt_RuleName" type="text" class="form-control" autocomplete="off" />
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="RulesDescription ">RulesDescription</label>
                          <textarea type="text" class="form-control" rows="5" id="RuleDescription"> </textarea>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="RulesActionofFailure ">Action of Failure</label>
                          <textarea type="text" class="form-control" rows="5" id="ActionofFailure"> </textarea>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="RulesHeadContent ">Head Content</label>
                          <textarea type="text" class="form-control" rows="5" id="RuleHeadContent"> </textarea>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="RulesBottomContent ">Bottom Content</label>
                          <textarea type="text" class="form-control" rows="5" id="BottomContent"> </textarea>
                        </div>
                      </div>

                    </div>
                    <!--Right side panel-->
                    <div class="col-6">
                      <div class="col-sm-12">
                        <div class="form-group" id="MailSubject">
                          <label for="RMailSubject">Mail Subject</label>
                          <textarea type="text" class="form-control" id="RuleMailSubject"> </textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="submit" (click)="UpdateBusinessRules()" class="btn btn-outline-success waves-effect waves-light">{{popupButtonText}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
